interface IntercomWindow {
  Intercom?: (command: string) => void
  intercomSettings?: unknown
}

/**
 * Kill the Intercom messenger even when react-use-intercom never booted it.
 *
 * The raw Intercom widget script self-starts a visitor-mode messenger whenever it
 * loads and finds an `app_id` in `window.intercomSettings` — which
 * `OptionalIntercomProvider` pre-sets before the provider mounts (see index.jsx).
 * That messenger was never booted through react-use-intercom, whose `shutdown()`
 * is guarded by an internal "have I booted?" ref and therefore no-ops against it,
 * leaving Chatwoot-allowlisted users with BOTH launchers (CL-1790).
 *
 * This helper works at the source instead: the raw `Intercom('shutdown')` command
 * takes effect even before the widget script has loaded (the bootstrap stub queues
 * commands and replays them on load), and deleting `window.intercomSettings`
 * prevents a later-loading script from self-starting again.
 */
export function forceShutdownIntercom(): void {
  if (typeof window === 'undefined') {
    return
  }
  const intercomWindow = window as IntercomWindow
  try {
    intercomWindow.Intercom?.('shutdown')
  } catch {
    // The messenger may be mid-initialization; deleting the settings below still
    // prevents it from (re)attaching.
  }
  delete intercomWindow.intercomSettings
}
